import { useSelector } from 'react-redux';
import BetaLabel from 'components/BetaLabel';
import { selectCurrentHistoryItem } from 'services/store/remixer/selectors';
import EditableTitle from 'pages/Remixer/components/Info/EditableTitle';
import RemixerTag from './RemixerTag';
import {
  StyledBetaLabelContainer,
  StyledInfoInner,
  StyledInfoWrapper,
  StyledTagsContainer,
} from './styled';

const Info = () => {
  const historyItem = useSelector(selectCurrentHistoryItem);
  const { formula } = historyItem || {};

  return (
    <StyledInfoWrapper>
      <StyledInfoInner>
        <EditableTitle />
        <StyledTagsContainer>
          {formula && <RemixerTag formula={formula} />}
        </StyledTagsContainer>
      </StyledInfoInner>
      <StyledBetaLabelContainer>
        <BetaLabel />
      </StyledBetaLabelContainer>
    </StyledInfoWrapper>
  );
};

export default Info;
